var wFlag=window.innerWidth>750

$(()=>{
    //box1
    new Swiper('.box1Swiper', {
        autoplay:true,
        loop:true,
        pagination: {
            el: '.newSwiper-pagination',
            clickable:true
        },
        navigation: {
            nextEl: '.newSwiper-button-next',
            prevEl: '.newSwiper-button-prev',
        },
    })

    //box2
    var box2Swiper = new Swiper('.box2Swiper', {
        autoplay: true,
        on:{
            slideChange: function(){
                var index = this.realIndex
                $('.box2_nav div:last-child p').eq(index).addClass('box2Active').siblings().removeClass('box2Active')
            }
        },
    })
    $('.box2_nav div:last-child p').click(function(){
        var index = $(this).index()
        box2Swiper.slideTo(index)
    })

    //box3
    ScrollTrigger.create({
        trigger: '.box3',
        start: wFlag?'top top':'top top+=10%',
        end: '+=100%',
        scrub:1,
        pin:true,
        animation: gsap.timeline()
            .to('.box3_line', { x:wFlag?'-34.5%':'-38%' })
            .to('.box3_line img', { scale:8 })
            .to('.box3_line', { opacity:0 },'-=0.5')
            .from('.box3_title,.box3_link,.box3_icon', { opacity:0 })
            .from('.box3Swiper', { opacity:0,y:'2rem' },'<'),
        // 正向滚动，整个动画结束后开始轮播
        onLeave() {
            box3Swiper.autoplay.start();
            box3Swiper.allowTouchMove = true;
        },

        // 从下方向上滚动，重新进入动画区域时停止轮播
        onEnterBack() {
            box3Swiper.autoplay.stop();
            box3Swiper.allowTouchMove = false;
        },

        // 动画尚未开始或重新进入时保持停止
        onEnter() {
            box3Swiper.autoplay.stop();
            box3Swiper.allowTouchMove = false;
        },

        onLeaveBack() {
            box3Swiper.autoplay.stop();
            box3Swiper.allowTouchMove = false;
        }
    })
    var box3Swiper = new Swiper('.box3Swiper', {
        loop:true,
        slidesPerView: wFlag?3:1,
        centeredSlides: true,
        allowTouchMove: false,
        // slideToClickedSlide: true,
        on:{
            slideChange: function(){
                var index = this.realIndex
                $('.box3_bg .box3_bgImg').removeClass('opacity1').eq(index).addClass('opacity1');
            }
        },
    })
    box3Swiper.slideTo(1, 0);

    //hero
    ScrollTrigger.create({
        trigger: '.demo-hero',
        start: wFlag?'top top+=20%':'top center',
        end: '+=20%',
        toggleActions:'play none none reverse',
        animation: gsap.timeline()
            .to('.dh_title div img', {y:0,scale:1})
            .to('.dh_title div c', {x:0},'<')
    })

    //box4
    showUp('.box4_title')
    new Swiper('.box4Swiper', {
        slidesPerView:wFlag?1.57:1,
        centeredSlides:true, 
        pagination: {
            el: '.box4Swiper-pagination',
            clickable :true,
        },
        loop:true,
        autoplay:{
            delay:5000
            // disableOnInteraction: false,
        },
        on:{
            slideChangeTransitionEnd: function(swiper){
                for(var i=0;i<$('.box4Swiper .box4_item video').length;i++){
                    if(i != $('.box4Swiper .swiper-slide-active').index()){
                        $('.box4Swiper .box4_item video')[i].pause()
                    }else{
                        $('.box4Swiper .swiper-slide-active')[0].children[0].children[0].play()
                    }
                }
            },
        },
    })

    $('.box4_text div:nth-child(2)').click(function(){
        var element = $(this).parents('.box4_item').children('video')[0]
        //是否全屏
        if(element.requestFullscreen){
            element.requestFullscreen()
        }
        //播放结束
        element.addEventListener('ended', function(){
            if (element.exitFullscreen) {
                element.exitFullscreen();
            } else if (element.webkitExitFullscreen) {
                element.webkitExitFullscreen();
            } else if (element.mozCancelFullScreen) {
                element.mozCancelFullScreen();
            } else if (element.msExitFullscreen) {
                element.msExitFullscreen();
            }
            //进度条
            element.currentTime = 0;
        })
    
    })

    //box5
    showUp('.box5_title')
    ScrollTrigger.create({
        trigger: '.box5',
        start: 'top center',
        //toggleActions: 'play none none reverse',
        animation: gsap.timeline()
            .from('.box5_item div', { opacity: 0, y: '2rem', stagger: 0.1 })
    })

})